import React from "react";
import styles from "./Projects.module.scss";
import Project from "./Project/Project.jsx";
const Projects = (props) => {
  return (
    <div className={styles.Projects} id="projects">
      <Project
        description="Highly customizable tree select written in React, that allows to read
    data directly from JSON file with certain convention."
        title="Tree Select"
        git="https://github.com/johnsvanda/tree-select"
        live="https://tree-select-react.herokuapp.com/"
      />

      <Project
        description="Chat web application built with socket.io, which enables real-time, bidirectional and event-based communication "
        title="Chat"
        git="https://github.com/johnsvanda/chat-room-backend"
        live="https://chat-socket-react.herokuapp.com/"
      />
      <Project
        description="Drag and drop image uploader that dynamically changes drag area, allows users to add or remove loaded files. Progression bar shows images uploading process."
        title="Image Uploader"
        git="https://github.com/johnsvanda/image-uploader"
        live="https://image-uploader-react.herokuapp.com/"
      />

      <Project
        description="Sign up, log in system using React, JWT Web Tokens, MongoDB, bcrypt... Restrictions as length of a password etc."
        title="Sign up/Sign in"
        git="https://github.com/johnsvanda/sign-up-in-backend"
        live="https://sign-in-up.herokuapp.com/"
      />
      <Project
        description="Website built without using any framework. Just pure HTML5, CSS3, JS"
        title="Seer website"
        git="https://github.com/johnsvanda/website_seer"
        live="https://jolly-meninsky-858794.netlify.com"
      />
      <Project
        description="Chrome extension using Gogole APIs(Translate, oAuth2), React, MaterialUI. (You have to be logged in through the extension, in case you want to use it.)"
        title="Translate Chrome Extension"
        git="https://github.com/johnsvanda/Chrome-Translate-Extension"
        live="https://github.com/johnsvanda/Chrome-Translate-Extension/archive/master.zip"
      />
      <Project
        description="Accommodation in small town Velká Bíteš, 1000+ people per month visit the website. (SEO optimized) ..."
        title="Accommodation website"
        git="https://github.com/johnsvanda/web_ubytovani/tree/master"
        live="http://www.ubytovani-velkabites.cz/"
      />
      <Project
        description="Chrome extension designed for private client to help navigate with coordinates from maps.google to mapy.cz, via context menu."
        title="Workflow Chrome Extension"
        git="https://github.com/johnsvanda/google-mapy.cz"
        live="https://github.com/johnsvanda/google-mapy.cz/archive/master.zip"
      />
    </div>
  );
};
export default Projects;
